'use strict';

import './component.scss';
import 'components/icon';

function init() {
    let toasts = document.querySelector("#toast-notifications").querySelectorAll(".toast-container");
    if (toasts.length > 0) {
        for (let i = 0, n = toasts.length; i < n; i++) {
            initToast(toasts[i]);
        }
    }
}

function initToast(toast) {
    if (toast) {
        measure(toast);

        toast.querySelector(".toast-close").addEventListener("click", clickToClose);

        let autoHideInterval = parseInt(toast.dataset.autoHide);
        if (autoHideInterval > 0) {
            setTimeout(() => close(toast), autoHideInterval * 1000);
        }
    }
}

function measure(toast) {
    toast.dataset.height = toast.offsetHeight;
    toast.style.height = toast.dataset.height + "px";
    toast.classList.add("toast-hide");

    setTimeout(() => toast.classList.remove("toast-hide"), 50);
}

function close(toast) {
    toast.classList.add("toast-hide");

    setTimeout(() => {
        let wrapper = toast.closest(".toast-wrapper");
        wrapper.parentNode.removeChild(wrapper);
    }, 300);
}

function clickToClose(e) {
    e.preventDefault();

    let toast = e.target.closest(".toast-container");

    close(toast);
}

function show(toastNotificationsHtml)
{
    if (toastNotificationsHtml) {
        let fragment = document.createRange().createContextualFragment(toastNotificationsHtml);
        let wrappers = fragment.querySelectorAll(".toast-wrapper");
        let placeholderEl = document.querySelector("#toast-notifications");

        for (let i = 0, n = wrappers.length; i < n; i++) {
            let toast = wrappers[i];
            toast = placeholderEl.appendChild(toast);
            toast = toast.querySelector(".toast-container")

            initToast(toast);
        }
    }
}

window.addEventListener("DOMContentLoaded", init);

export default { show };